import { DatePicker, Select, TimePicker } from "antd";
import moment from "moment";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getLocal } from "../../../helpers/Local";
import {
  getFollowUp,
  getTimeSlots,
  get_plan_patient,
  rescheduleProcedure,
  saveProcedureSchedule,
  setGlobalLoading,
  setProcedureData,
} from "../../../store/actions";
import { ExpandSVG, LeftCharvenSVG } from "../icons/SVGIcon";

const { Option } = Select;

const getValue = (options, target, key) => {
  let opt = [];
  if (options && key && target) {
    opt = (options || []).find((option) => option[key].toString() === target.toString());
  }
  if (opt) {
    return opt?.value;
  }
  return "";
};

let timer = null;

const ClinicDiseaseComponent = ({
  procedure_id_row,
  checkUltra,
  nextSave,
  titlePlan,
  activeRow,
  onButton,
  plans,
  planTypes,
  typePlanId,
  changeSetProcessHandle,
  currentPlanId,
  activeStatus,
  is_locked,
}) => {
  const locations = useSelector((state) => state.procedure.locations);
  const current_patient_id = getLocal("current_patient_id");
  const current_appointment_id = getLocal("current_appointment_id");
  const providers = useSelector((state) => state.procedure.providers);
  const clincLocations = useSelector((state) => state.procedure.clincLocations);
  const followupProviders = useSelector((state) => state.procedure.followupProviders);
  const data = useSelector((state) => state.patientSchedule);
  const loading = useSelector((state) => state.procedure.loadingSchedule);
  const planDetails = useSelector((state) => state.procedure.planDetails);
  const loadingFirst = useSelector((state) => state.procedure.loadingTimeSlots);
  const loadingSecond = useSelector((state) => state.procedure.loadingFollowUp);
  const timeSlotsCheck = useSelector((state) => state.procedure.timeSlots);
  const followupSlotsCheck = useSelector((state) => state.procedure.followupSlots);
  const firstClinic = useSelector((state) => state.procedure.timeSlot);
  const secondClinic = useSelector((state) => state.procedure.followSlot);
  const [timeSlots, setTimeSlots] = useState([]);
  const [lock, setLock] = useState(false);
  const [followupSlots, setFollowupSlots] = useState([]);
  //
  const [appointment_date_check, setAppointment_date] = useState(null);
  const [followup_appointment_check, setFollowup_appointment] = useState(null);
  //
  const [checkDetail, setCheckDetail] = useState({});
  const [endarterectomy, setEndarterectomy] = useState([]);
  const [follow_Up, setFollow_Up] = useState([]);
  const dispatch = useDispatch();
  const [areSlotsReady, setAreSlotsReady] = useState(false);

  useEffect(() => {
    setFollowupSlots(followupSlotsCheck);
    fetchFollowup(followupSlotsCheck);
  }, [followupSlotsCheck, typePlanId]);

  useEffect(() => {
    setTimeSlots(timeSlotsCheck);
    fetchTime(timeSlotsCheck);
  }, [timeSlotsCheck, typePlanId]);

  useEffect(() => {
    if (timeSlots && timeSlots.length > 0 && followupSlots && followupSlots.length > 0) {
      setAreSlotsReady(true);
    }
  }, [timeSlots, followupSlots]);

  const removeState = () => {
    dispatch(setProcedureData("timeSlot", -1));
    setTimeOption({
      location: undefined,
      provider: undefined,
      period: undefined,
      prev_date: undefined,
    });
    setCustomAppointment({
      first: {},
      second: {},
    });
    setFollowOption({
      location: undefined,
      provider: undefined,
      period: undefined,
      prev_date: undefined,
    });
    dispatch(setProcedureData("followSlot", -1));
    setAppointment_date(null);
    setFollowup_appointment(null);
  };

  useEffect(() => {
    if (is_locked && areSlotsReady) {
      const findCondition = plans.find((r) => r.condition_id == typePlanId);
      if (findCondition && findCondition.plan && findCondition.plan.length > 0) {
        const findPlan = findCondition.plan.find((r) => r.id == currentPlanId);
        if (findPlan && findPlan.id) {
          setTimeSlots((prevTimeSlots) => [
            {
              start: findPlan?.angio?.appointment_date ? moment(findPlan?.angio?.appointment_date).format("MM/DD/YYYY") : "",
              location: findPlan?.angio?.location?.id,
              provider: findPlan?.angio?.provider?.id,
              start_slot: findPlan?.angio?.appointment_date ? moment(findPlan?.angio?.appointment_date).format("hh:mm AA") : "",
            },
            ...prevTimeSlots.slice(1),
          ]);
          setFollowupSlots((prevFollowupSlots) => [
            {
              start: findPlan?.followup_appointment?.appointment_date
                ? moment(findPlan?.followup_appointment?.appointment_date).format("MM/DD/YYYY")
                : "",
              location: findPlan?.followup_appointment?.location?.id,
              provider: findPlan?.followup_appointment?.provider?.id,
              provider_value: findPlan?.followup_appointment?.provider?.value,
              doctor: findPlan?.followup_appointment?.provider?.id,
              start_slot: findPlan?.followup_appointment?.appointment_date
                ? moment(findPlan?.followup_appointment?.appointment_date).format("hh:mm AA")
                : "",
            },
            ...prevFollowupSlots.slice(1),
          ]);
        }
      }
    }
  }, [is_locked, typePlanId, plans, currentPlanId, areSlotsReady]);

  const fetchFrist = async () => {
    removeState();
    await setCheckDetail({});
    if (plans && plans.length > 0) {
      const check = plans.find((r) => r.condition_id == typePlanId);
      if (check) {
        const checkDetail = (check["plan"] || []).filter((r) => r.entity_id == procedure_id_row);
        if (checkDetail && checkDetail[0]) {
          await setCheckDetail(checkDetail[0]);
        } else {
          await setCheckDetail(null);
        }
      }
    }
  };

  const fetchTime = async (timeSlotsCheck) => {
    (timeSlotsCheck || []).map(async (slot, index) => {
      if (moment(slot.start).format("MM/DD/YYYY") === moment(checkDetail?.procedure?.appointment_date).format("MM/DD/YYYY")) {
        dispatch(setProcedureData("timeSlot", index));
      } else {
        dispatch(setProcedureData("timeSlot", -1));
      }
    });
  };

  const fetchFollowup = async (followupSlotsCheck) => {
    (followupSlotsCheck || []).map((slot, index) => {
      if (moment(slot.start).format("MM/DD/YYYY") === moment(checkDetail?.followup_appointment?.appointment_date).format("MM/DD/YYYY")) {
        dispatch(setProcedureData("followSlot", index));
      } else {
        dispatch(setProcedureData("followSlot", -1));
      }
    });
  };

  useEffect(() => {
    if (!is_locked) {
      if (checkDetail && Object.keys(checkDetail).length > 0) {
        if (checkDetail?.procedure?.appointment_date) {
          const value = moment(checkDetail?.procedure?.appointment_date).format("MM/DD/YYYY");
          setAppointment_date(value || null);
        } else {
          setAppointment_date(null);
        }
        if (checkDetail?.followup_appointment?.appointment_date) {
          const value = moment(checkDetail?.followup_appointment?.appointment_date).format("MM/DD/YYYY");
          setFollowup_appointment(value || null);
        } else {
          setFollowup_appointment(null);
        }
      } else {
        setAppointment_date(null);
        setFollowup_appointment(null);
        dispatch(setProcedureData("timeSlot", -1));
        dispatch(setProcedureData("followSlot", -1));
      }
    }
  }, [checkDetail, typePlanId, procedure_id_row, data, is_locked]);

  useEffect(() => {
    if (checkDetail && Object.keys(checkDetail).length > 0) {
      const newOption = {
        location: "",
        provider: "",
        period: checkDetail?.procedure?.appointment_date ? moment(checkDetail?.procedure?.appointment_date).format("MM/DD/YYYY") : "",
        prev_date: "",
      };
      dispatch(getFollowUp(data && data.selectedPatientResource && data.selectedPatientResource?.id, procedure_id_row, newOption, false, false));
    }
  }, [checkDetail]);

  useEffect(() => {
    fetchFrist();
  }, [procedure_id_row, plans, typePlanId, activeRow]);

  const [activeCustom, setActiveCustom] = useState({
    first: false,
    second: false,
  });

  const [customAppointment, setCustomAppointment] = useState({
    first: {},
    second: {},
  });

  const [timeOption, setTimeOption] = useState({
    location: "",
    provider: "",
    period: "",
    prev_date: "",
  });
  const [followOption, setFollowOption] = useState({
    location: "",
    provider: "",
    period: "",
    prev_date: "",
  });
  const [questions, setQuestions] = useState({
    taking_metformin: -1,
    taking_eliquis: -1,
    taking_coumadin: -1,
    taking_plavix: -1,
    receive_coronary_stent: -1,
  });

  const saveAllDate = (type) => {
    if (type === "time") {
      if (timeSlots && timeSlots[0]) {
        const checkTimeSlots = timeSlots[0];
        if (checkTimeSlots) {
          if (endarterectomy && !endarterectomy.some((r) => r.start === checkTimeSlots.start)) {
            setEndarterectomy([...endarterectomy, checkTimeSlots]);
          }
        }
      }
    }

    if (type === "follow") {
      if (followupSlots && followupSlots[0]) {
        const checkFollowupSlots = followupSlots[0];
        if (checkFollowupSlots) {
          if (follow_Up && !follow_Up.some((r) => r.start === checkFollowupSlots.start)) {
            setFollow_Up([...follow_Up, checkFollowupSlots]);
          }
        }
      }
    }
  };

  const handleCustomChange = (idx, type, value) => {
    const customAppointments = { ...customAppointment };
    customAppointments[idx][type] = value;
    setCustomAppointment(customAppointments);
  };

  const toggleCustom = (type) => {
    const isCustomArray = { ...activeCustom };
    const customAppointments = { ...customAppointment };
    isCustomArray[type] = !isCustomArray[type];
    customAppointments[type] = isCustomArray[type]
      ? {
          location: "",
          date: "",
          time: "",
          provider: "",
        }
      : {};

    setActiveCustom(isCustomArray);
    setCustomAppointment(customAppointments);
  };

  const callApiDetail = async () => {
    clearTimeout(timer);
    await dispatch(setGlobalLoading(true));
    timer = setTimeout(async () => {
      if (procedure_id_row) {
        await dispatch(rescheduleProcedure(current_patient_id, procedure_id_row, {}, false));
        await dispatch(setGlobalLoading(false));
      }
    }, 100);
  };

  useEffect(() => {
    if (procedure_id_row && procedure_id_row != 0) {
      callApiDetail();
    }
  }, [procedure_id_row]);

  const title = useMemo(() => {
    if (planDetails && planDetails.procedure) {
      return planDetails.procedure;
    } else {
      if (planDetails && planDetails.ultrasound && planDetails.ultrasound.us_test) {
        return planDetails.ultrasound.us_test?.name;
      }
    }
  }, [planDetails]);

  const setFiirst = (index) => {
    dispatch(setProcedureData("timeSlot", index));
  };
  const setSecond = async (index) => {
    await dispatch(setProcedureData("followSlot", index));
  };

  const onSaveSchedule = async (firstClinicCheck, timeSlotsCheck, secondClinicCheck, followupSlotsCheck) => {
    const timeSlot =
      timeSlotsCheck && firstClinicCheck && firstClinicCheck > -1
        ? timeSlotsCheck[firstClinicCheck]
        : timeSlotsCheck && timeSlotsCheck[0]
          ? timeSlotsCheck[0]
          : "";
    const followup =
      followupSlotsCheck && secondClinicCheck && secondClinicCheck > -1
        ? followupSlotsCheck[secondClinicCheck]
        : followupSlotsCheck && followupSlotsCheck[0]
          ? followupSlotsCheck[0]
          : "";
    if (timeSlot && followup) {
      dispatch(setGlobalLoading(true));
      const params = {
        procedure_date: moment(timeSlot.start).format("MM/DD/YYYY"),
        procedure_time: moment(timeSlot.start).format("hh:mm A"),
        procedure_location: timeSlot.location,
        procedure_provider: timeSlot.provider,
        followup_date: moment(followup.start).format("MM/DD/YYYY"),
        followup_time: moment(followup.start).format("hh:mm A"),
        followup_location: followup.location,
        followup_provider: followup.provider,
        followup_start_slot: followup?.start_slot,
        followup_doctor: followup.doctor,
        doc_slot: followup.start_slot,
        plan_id: currentPlanId,
      };
      const loadingSuccess = await dispatch(setProcedureData("loadingSchedule", true));
      const SaveSuccess = await dispatch(saveProcedureSchedule(procedure_id_row, params));
      const loadList = await dispatch(get_plan_patient(current_patient_id, current_appointment_id));
      if (loadingSuccess && SaveSuccess) {
        if (changeSetProcessHandle) {
          changeSetProcessHandle(activeRow, typePlanId, params, "ClinicDisease");
        }
        if (nextSave) {
          nextSave(loadList);
          setFiirst(-1);
          setSecond(-1);
          setAppointment_date(null);
          setFollowup_appointment(null);
        }
      }
      dispatch(setGlobalLoading(false));
    }
  };

  const onLoadCheck = async (firstClinicCheck, timeSlotsCheck, secondClinicCheck, followupSlotsCheck) => {
    if (firstClinicCheck != -1 && secondClinicCheck != -1) {
      setLock(false);
    } else {
      setLock(true);
    }
  };

  useEffect(() => {
    onLoadCheck(firstClinic, timeSlots, secondClinic, followupSlots);
  }, [firstClinic, secondClinic, timeSlots, followupSlots]);

  const handleChangeSlots = (type) => async (value) => {
    dispatch(setGlobalLoading(true));
    const prev_date =
      firstClinic !== -1
        ? moment(timeSlots[firstClinic].start).format("MM/DD/YYYY")
        : timeSlots[0]
          ? moment(timeSlots[0].start).format("MM/DD/YYYY")
          : "";
    const newOption = { ...timeOption, [type]: value };
    setTimeOption(newOption);
    await dispatch(setProcedureData("loadingTimeSlots", true));
    await dispatch(getTimeSlots(current_patient_id, procedure_id_row, newOption));
    dispatch(setGlobalLoading(false));
    setFiirst(-1);
  };

  const handleChangeFollow = (type) => (value) => {
    const prev_date =
      secondClinic !== -1
        ? moment(followupSlots[secondClinic].start).format("MM/DD/YYYY")
        : followupSlots[0]
          ? moment(followupSlots[0].start).format("MM/DD/YYYY")
          : timeSlots[firstClinic]
            ? moment(timeSlots[firstClinic].start).format("MM/DD/YYYY")
            : "";
    const newOption = { ...followOption, prev_date, [type]: value };
    setFollowOption(newOption);
    dispatch(setProcedureData("loadingFollowUp", true));
    dispatch(getFollowUp(current_patient_id, procedure_id_row, newOption));
    setSecond(-1);
  };

  const handleTimeSlot = (value, index) => {
    const mixSlot = [...timeSlots];
    mixSlot[index]["start_slot"] = value;
    const dateSlot = moment()
      .hours(8)
      .minutes(0)
      .add(value * 15, "minutes")
      .format("HH:mm:ss");
    if (mixSlot[index]["start"] && mixSlot[index]["start"].includes(" ")) {
      const mixSplit = mixSlot[index]["start"].split(" ");
      if (mixSplit[0]) {
        mixSlot[index]["start"] = `${mixSplit[0]} ${dateSlot}`;
      }
    }
    if (timeSlots[index].start) {
      const value = moment(timeSlots[index].start).format("MM/DD/YYYY");
      setAppointment_date(value || "");
    }
    setTimeSlots(mixSlot);
  };

  const handleTimeSlotFollow = (value, index) => {
    const mixSlot = [...followupSlots];
    const dateSlot = moment()
      .hours(8)
      .minutes(0)
      .add(value * 15, "minutes")
      .format("HH:mm:ss");
    mixSlot[index]["start_slot"] = value;
    if (mixSlot[index]["start"] && mixSlot[index]["start"].includes(" ")) {
      const mixSplit = mixSlot[index]["start"].split(" ");
      if (mixSplit[0]) {
        mixSlot[index]["start"] = `${mixSplit[0]} ${dateSlot}`;
      }
    }
    if (followupSlots[index].start) {
      const value = moment(followupSlots[index].start).format("MM/DD/YYYY");
      setFollowup_appointment(value || "");
    }
    setFollowupSlots(mixSlot);
  };

  const selectTimeSlot = (row, index) => {
    if (!is_locked) {
      setFollow_Up([]);
      const newOption = {
        location: row.location,
        provider: row.provider,
        prev_date: moment(row.start).format("MM/DD/YYYY"),
        period: moment(row.start).format("A"),
      };
      setFiirst(index);
      setSecond(-1);
      setFollowup_appointment(null);
      dispatch(setProcedureData("loadingFollowUp", true));
      dispatch(
        getFollowUp(
          current_patient_id,
          procedure_id_row,
          {
            ...followOption,
            prev_date: moment(row.start).format("MM/DD/YYYY"),
          },
          false,
          "true"
        )
      );
    }
  };

  const onHandleClick = () => {
    onSaveSchedule(firstClinic, timeSlots, secondClinic, followupSlots);
  };

  const handleMoreDates = (type) => {
    saveAllDate(type);
    if (timeSlots && timeSlots.length > 0 && type === "time") {
      const option = {
        ...timeOption,
        prev_date: moment(timeSlots[timeSlots.length - 1].start).format("MM/DD/YYYY"),
      };
      setTimeOption(option);
      dispatch(setProcedureData("loadingTimeSlots", true));
      dispatch(getTimeSlots(data && data.selectedPatientResource && data.selectedPatientResource?.id, procedure_id_row, option, false, false));
      setFiirst(-1);
    }
    if (followupSlots && followupSlots.length > 0 && type === "follow") {
      const newOption = {
        ...followOption,
        prev_date: moment(followupSlots[followupSlots.length - 1].start).format("MM/DD/YYYY"),
      };
      setFollowOption(newOption);
      dispatch(setProcedureData("loadingFollowUp", true));
      dispatch(getFollowUp(data && data.selectedPatientResource && data.selectedPatientResource?.id, procedure_id_row, newOption, false, false));
      setSecond(-1);
    }
  };

  const handleQuestions = (type) => (value) => {
    const questionnaire = { ...questions, [type]: value };
    setQuestions(questionnaire);
  };

  const previous = (type) => {
    if (endarterectomy && endarterectomy.length > 0 && type === "time") {
      const option = {
        ...timeOption,
        prev_date: moment(endarterectomy[endarterectomy.length - 1].start).format("MM/DD/YYYY"),
      };
      setTimeOption(option);
      dispatch(setProcedureData("loadingTimeSlots", true));
      dispatch(getTimeSlots(data && data.selectedPatientResource && data.selectedPatientResource?.id, procedure_id_row, option));
      setFiirst(-1);
      const aa = endarterectomy;
      if (aa) {
        aa.splice(endarterectomy.length - 1, 1);
        setEndarterectomy(aa);
      }
    }
    if (follow_Up && follow_Up.length > 0 && type === "follow") {
      const newOption = {
        ...followOption,
        prev_date: moment(follow_Up[follow_Up.length - 1].start).format("MM/DD/YYYY"),
      };
      setFollowOption(newOption);
      dispatch(setProcedureData("loadingFollowUp", true));
      dispatch(getFollowUp(data && data.selectedPatientResource && data.selectedPatientResource?.id, procedure_id_row, newOption));
      setSecond(-1);
      const aa = follow_Up;
      if (aa) {
        aa.splice(follow_Up.length - 1, 1);
        setFollow_Up(aa);
      }
    }
  };

  const checkActive = (slot) => {
    if (appointment_date_check && moment(slot.start).format("MM/DD/YYYY") === moment(appointment_date_check).format("MM/DD/YYYY")) {
      return "active";
    }
    return "";
  };

  const checkFollowActive = (slot) => {
    if (followup_appointment_check && moment(slot.start).format("MM/DD/YYYY") === moment(followup_appointment_check).format("MM/DD/YYYY")) {
      return "active";
    }
    return "";
  };
  return (
    <>
      <div className="resourceContent">
        <div className="resourceInfo d-flex" style={{ justifyContent: "space-between" }}>
          <b>{`${titlePlan}`}</b>
        </div>

        <div style={{ position: "relative", marginBottom: "4px" }}>
          <div className="resourceInfo between mt-2 sortableHeader" style={{ background: "#f4f7fb" }}>
            <div
              className={`th sortable w-25 hide-icon`}
              style={{
                paddingLeft: "2px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                alignSelf: "stretch",
                borderLeft: "1px solid #dfe3e6",
              }}
            >
              <Select
                disabled={is_locked}
                value={timeOption.location}
                placeholder="Location"
                suffixIcon={<span />}
                allowClear={true}
                style={{
                  maxWidth: "100%",
                  width: "100%",
                  background: "transparent",
                  borderBottom: 0,
                  boxShadow: "none",
                }}
                onChange={handleChangeSlots("location")}
              >
                {(locations || []).map((loc, index) => (
                  <Option key={`location-${loc?.id}-${index}`} value={loc?.id}>
                    {loc?.value}
                  </Option>
                ))}
              </Select>
            </div>
            <div
              className={`th sortable w-25 hide-icon`}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                alignSelf: "stretch",
                borderLeft: "1px solid #dfe3e6",
              }}
            >
              Date
              <div>
                <button
                  disabled={loading || loadingFirst || is_locked}
                  className="more-dates backward"
                  style={{
                    padding: "2px",
                    minWidth: "unset",
                    width: "auto",
                    height: "auto",
                    border: "none",
                    background: "transparent",
                    color: "#3d70be",
                    marginTop: 0,
                  }}
                  onClick={() => {
                    previous("time");
                  }}
                >
                  <LeftCharvenSVG />
                </button>
                <button
                  disabled={loading || loadingFirst || is_locked}
                  className="more-dates forward"
                  style={{
                    padding: "2px",
                    minWidth: "unset",
                    width: "auto",
                    height: "auto",
                    border: "none",
                    background: "transparent",
                    color: "#3d70be",
                    marginTop: 0,
                  }}
                  onClick={() => {
                    handleMoreDates("time");
                  }}
                >
                  <LeftCharvenSVG />
                </button>
              </div>
            </div>
            <div
              className={`th sortable w-25 hide-icon`}
              style={{
                paddingLeft: "2px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                alignSelf: "stretch",
                borderLeft: "1px solid #dfe3e6",
              }}
            >
              <Select
                disabled={is_locked}
                value={timeOption.period}
                placeholder="Time"
                suffixIcon={<span />}
                onChange={handleChangeSlots("period")}
                style={{
                  maxWidth: "100%",
                  width: "100%",
                  background: "transparent",
                  borderBottom: 0,
                  boxShadow: "none",
                }}
              >
                <Option value="am">AM</Option>
                <Option value="pm">PM</Option>
              </Select>
            </div>
            <div
              className={`th sortable w-25 hide-icon`}
              style={{
                paddingLeft: "2px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                alignSelf: "stretch",
                borderLeft: "1px solid #dfe3e6",
              }}
            >
              <Select
                disabled={is_locked}
                placeholder="Provider"
                value={timeOption.provider}
                suffixIcon={<span />}
                allowClear={true}
                mod="multiple"
                onChange={handleChangeSlots("provider")}
                style={{
                  maxWidth: "100%",
                  width: "100%",
                  background: "transparent",
                  borderBottom: 0,
                  boxShadow: "none",
                }}
              >
                {(providers || []).map((provider, index) => (
                  <Option key={`provider-${provider?.id}-${index}`} value={provider?.id}>
                    {provider?.value}
                  </Option>
                ))}
              </Select>
            </div>
          </div>
          {!loadingFirst &&
            (timeSlots || []).map((slot, index) => (
              <React.Fragment key={`time-slots-${index}`}>
                <div
                  className={`resourceInfo between t-row 
                ${checkActive(slot) === "active" && firstClinic !== index && firstClinic == -1 ? "active" : ""} ${
                  firstClinic === index ? "active" : ""
                } ${is_locked && index === 0 ? "active" : ""}`}
                  style={{ alignItems: "center" }}
                  onClick={() => selectTimeSlot(slot, index)}
                >
                  <div className="w-25">{getValue(locations, slot.location, "id")}</div>
                  <div className="w-25">{slot.start && moment(slot.start).format("MM/DD/YYYY")}</div>
                  <div
                    className="w-25"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      paddingLeft: 0,
                      marginTop: 0,
                    }}
                  >
                    <Select
                      disabled={is_locked}
                      placeholder="Timer check all"
                      value={slot?.start_slot}
                      suffixIcon={<ExpandSVG />}
                      allowClear={false}
                      style={{
                        maxWidth: "100%",
                        width: "100%",
                      }}
                      onChange={(value) => {
                        handleTimeSlot(value, index);
                      }}
                    >
                      {(slot?.slots || []).map((time, index) => (
                        <Option key={`time-${time}-${index}`} value={time}>
                          {moment()
                            .hours(8)
                            .minutes(0)
                            .add(time * 15, "minutes")
                            .format("hh:mm A")}
                        </Option>
                      ))}
                    </Select>
                  </div>
                  <div className="w-25">{getValue(providers, slot.provider, "id")}</div>
                </div>
                <hr className="small-block" />
              </React.Fragment>
            ))}
          {!loadingFirst && Array.isArray(timeSlots) && timeSlots.length == 0 ? (
            <div style={{ textAlign: "center", marginTop: 10 }}>There are no available appointments for time period selected</div>
          ) : null}
          {loadingFirst && (
            <React.Fragment key={`time-slots-1`}>
              <div className={`resourceInfo between t-row`} style={{ alignItems: "center" }}>
                <div className="w-25"></div>
                <div className="w-25"></div>
                <div className="w-25"></div>
                <div className="w-25"></div>
              </div>
              <hr className="small-block" />
              <div className={`resourceInfo between t-row`} style={{ alignItems: "center" }}>
                <div className="w-25"></div>
                <div className="w-25"></div>
                <div className="w-25"></div>
                <div className="w-25"></div>
              </div>
              <hr className="small-block" />
              <div className={`resourceInfo between t-row`} style={{ alignItems: "center" }}>
                <div className="w-25"></div>
                <div className="w-25"></div>
                <div className="w-25"></div>
                <div className="w-25"></div>
              </div>
            </React.Fragment>
          )}
        </div>

        {activeCustom["first"] && (
          <div className="resourceInfo between mt-2 sortableHeader" style={{ background: "#f4f7fb" }}>
            <div
              className={`th sortable w-25 hide-icon`}
              style={{
                paddingLeft: "2px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                alignSelf: "stretch",
                borderLeft: "1px solid #dfe3e6",
              }}
            >
              <Select
                disabled={is_locked}
                placeholder="Location"
                value={customAppointment["first"].location || undefined}
                suffixIcon={<span />}
                allowClear={true}
                style={{
                  maxWidth: "100%",
                  width: "100%",
                  background: "transparent",
                  borderBottom: 0,
                  boxShadow: "none",
                }}
                onChange={(value) => handleCustomChange("first", "location", value)}
              >
                {(locations || []).map((loc, index) => (
                  <Option key={`location-${loc?.id}-${index}`} value={loc?.id}>
                    {loc?.value}
                  </Option>
                ))}
              </Select>
            </div>

            <div
              className={`th sortable w-25 hide-icon`}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                alignSelf: "stretch",
                paddingLeft: 0,
                borderLeft: "1px solid #dfe3e6",
              }}
            >
              <DatePicker
                disabled={is_locked}
                onChange={(value) => {
                  handleCustomChange("first", "date", moment(value).format("MM/DD/YYYY"));
                }}
                style={{
                  width: "100%",
                  minWidth: "100%",
                  background: "transparent",
                  boxShadow: "none",
                  borderBottom: 0,
                }}
                format={"MM/DD/YYYY"}
                placeholder="Date"
                suffixIcon={<ExpandSVG />}
              />
            </div>

            <div
              className={`th sortable w-25 hide-icon`}
              style={{
                paddingLeft: "2px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                alignSelf: "stretch",
                borderLeft: "1px solid #dfe3e6",
              }}
            >
              <TimePicker
                disabled={is_locked}
                format={"h:mm A"}
                use12Hours
                placeholder="Time"
                style={{
                  maxWidth: "100%",
                  width: "100%",
                  background: "transparent",
                  boxShadow: "none",
                  borderBottom: 0,
                }}
                disabledHours={() => [0, 1, 2, 3, 4, 5, 20, 21, 22, 23]}
                minuteStep={15}
                onChange={(value) => handleCustomChange("first", "time", moment(value).format("h:mm A"))}
              />
            </div>

            <div
              className={`th sortable w-25 hide-icon`}
              style={{
                paddingLeft: "2px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                alignSelf: "stretch",
                borderLeft: "1px solid #dfe3e6",
              }}
            >
              <Select
                disabled={is_locked}
                placeholder="Provider"
                value={customAppointment["first"].provider || undefined}
                suffixIcon={<span />}
                allowClear={true}
                style={{
                  maxWidth: "100%",
                  width: "100%",
                  background: "transparent",
                  borderBottom: 0,
                  boxShadow: "none",
                }}
                onChange={(value) => handleCustomChange("first", "provider", value)}
              >
                {(providers || []).map((provider, index) => (
                  <Option key={`provider-${provider?.id}-${index}`} value={provider?.id}>
                    {provider?.value}
                  </Option>
                ))}
              </Select>
            </div>
          </div>
        )}

        <div style={{ marginTop: "1.5rem" }}>
          <div className="resourceInfo d-flex" style={{ justifyContent: "space-between" }}>
            <b>{`${titlePlan} Follow-Up`}</b>
          </div>

          <div style={{ position: "relative", marginBottom: "4px" }}>
            <div className="resourceInfo between mt-2 sortableHeader" style={{ background: "#f4f7fb" }}>
              <div
                className={`th sortable w-25 hide-icon`}
                style={{
                  paddingLeft: "2px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  alignSelf: "stretch",
                  borderLeft: "1px solid #dfe3e6",
                }}
              >
                <Select
                  disabled={is_locked}
                  value={followOption.location}
                  placeholder="Location"
                  suffixIcon={<span />}
                  allowClear={true}
                  onChange={handleChangeFollow("location")}
                  style={{
                    maxWidth: "100%",
                    width: "100%",
                    background: "transparent",
                    borderBottom: 0,
                    boxShadow: "none",
                  }}
                >
                  {(clincLocations || []).map((loc, index) => (
                    <Option key={`location-${loc?.id}-${index}`} value={loc?.id}>
                      {loc?.value}
                    </Option>
                  ))}
                </Select>
              </div>
              <div
                className={`th sortable w-25 hide-icon`}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  alignSelf: "stretch",
                  borderLeft: "1px solid #dfe3e6",
                }}
              >
                Date
                <div>
                  <button
                    disabled={loading || loadingSecond || is_locked}
                    className="more-dates backward"
                    style={{
                      padding: "2px",
                      minWidth: "unset",
                      width: "auto",
                      height: "auto",
                      border: "none",
                      background: "transparent",
                      color: "#3d70be",
                      marginTop: 0,
                    }}
                    onClick={() => {
                      previous("follow");
                    }}
                  >
                    <LeftCharvenSVG />
                  </button>
                  <button
                    disabled={loading || loadingSecond || is_locked}
                    className="more-dates forward"
                    style={{
                      padding: "2px",
                      minWidth: "unset",
                      width: "auto",
                      height: "auto",
                      border: "none",
                      background: "transparent",
                      color: "#3d70be",
                      marginTop: 0,
                    }}
                    onClick={() => {
                      handleMoreDates("follow");
                    }}
                  >
                    <LeftCharvenSVG />
                  </button>
                </div>
              </div>
              <div
                className={`th sortable w-25 hide-icon`}
                style={{
                  paddingLeft: "2px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  alignSelf: "stretch",
                  borderLeft: "1px solid #dfe3e6",
                }}
              >
                <Select
                  disabled={is_locked}
                  placeholder="Time"
                  value={followOption.period}
                  onChange={handleChangeFollow("period")}
                  suffixIcon={<span />}
                  style={{
                    maxWidth: "100%",
                    width: "100%",
                    background: "transparent",
                    borderBottom: 0,
                    boxShadow: "none",
                  }}
                >
                  <Option value="am">AM</Option>
                  <Option value="pm">PM</Option>
                </Select>
              </div>
              <div
                className={`th sortable w-25 hide-icon`}
                style={{
                  paddingLeft: "2px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  alignSelf: "stretch",
                  borderLeft: "1px solid #dfe3e6",
                }}
              >
                <Select
                  disabled={is_locked}
                  placeholder="Provider"
                  suffixIcon={<span />}
                  allowClear={true}
                  value={followOption.provider}
                  onChange={handleChangeFollow("provider")}
                  style={{
                    maxWidth: "100%",
                    width: "100%",
                    background: "transparent",
                    borderBottom: 0,
                    boxShadow: "none",
                  }}
                >
                  {(followupProviders || []).map((provider, index) => (
                    <Option key={`provider-${provider?.id}-${index}`} value={provider?.id}>
                      {provider?.value}
                    </Option>
                  ))}
                </Select>
              </div>
            </div>
            {!loadingSecond &&
              (followupSlots || []).map((slot, index) => (
                <React.Fragment key={`time-slots-${index}`}>
                  <div
                    className={`resourceInfo between t-row 
                  ${checkFollowActive(slot) === "active" && secondClinic !== index && secondClinic == -1 ? "active" : ""} ${
                    secondClinic === index ? "active" : ""
                  } ${is_locked && index === 0 ? "active" : ""}`}
                    style={{ alignItems: "center" }}
                    onClick={() => setSecond(index)}
                  >
                    <div className="w-25">{getValue(clincLocations, slot.location, "id")}</div>
                    <div className="w-25">{slot.start && moment(slot.start).format("MM/DD/YYYY")}</div>
                    <div
                      className="w-25"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        paddingLeft: 0,
                        marginTop: 0,
                      }}
                    >
                      <Select
                        disabled={is_locked}
                        placeholder="Timer check all"
                        value={slot?.start_slot}
                        suffixIcon={<ExpandSVG />}
                        allowClear={false}
                        style={{
                          maxWidth: "100%",
                          width: "100%",
                        }}
                        onChange={(value) => {
                          handleTimeSlotFollow(value, index);
                        }}
                      >
                        {(slot?.slots || []).map((time, index) => (
                          <Option key={`time-${time}-${index}`} value={time}>
                            {moment()
                              .hours(8)
                              .minutes(0)
                              .add(time * 15, "minutes")
                              .format("hh:mm A")}
                          </Option>
                        ))}
                      </Select>
                    </div>
                    <div className="w-25">{getValue(followupProviders, slot.doctor, "id")}</div>
                  </div>
                  <hr className="small-block" />
                </React.Fragment>
              ))}
          </div>
          {loadingSecond && (
            <React.Fragment key={`time-slots-2`}>
              <div className={`resourceInfo between t-row`} style={{ alignItems: "center" }}>
                <div className="w-25"></div>
                <div className="w-25"></div>
                <div className="w-25"></div>
                <div className="w-25"></div>
              </div>
              <hr className="small-block" />
              <div className={`resourceInfo between t-row`} style={{ alignItems: "center" }}>
                <div className="w-25"></div>
                <div className="w-25"></div>
                <div className="w-25"></div>
                <div className="w-25"></div>
              </div>
              <hr className="small-block" />
              <div className={`resourceInfo between t-row`} style={{ alignItems: "center" }}>
                <div className="w-25"></div>
                <div className="w-25"></div>
                <div className="w-25"></div>
                <div className="w-25"></div>
              </div>
            </React.Fragment>
          )}
          {activeCustom["second"] && (
            <div className="resourceInfo between mt-2 sortableHeader" style={{ background: "#f4f7fb" }}>
              <div
                className={`th sortable w-25 hide-icon`}
                style={{
                  paddingLeft: "2px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  alignSelf: "stretch",
                  borderLeft: "1px solid #dfe3e6",
                }}
              >
                <Select
                  disabled={is_locked}
                  placeholder="Location"
                  value={customAppointment["second"].location || undefined}
                  suffixIcon={<span />}
                  allowClear={true}
                  style={{
                    maxWidth: "100%",
                    width: "100%",
                    background: "transparent",
                    borderBottom: 0,
                    boxShadow: "none",
                  }}
                  onChange={(value) => handleCustomChange("second", "location", value)}
                >
                  {(clincLocations || []).map((loc, index) => (
                    <Option key={`location-${loc?.id}-${index}`} value={loc?.id}>
                      {loc?.value}
                    </Option>
                  ))}
                </Select>
              </div>

              <div
                className={`th sortable w-25 hide-icon`}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  alignSelf: "stretch",
                  paddingLeft: 0,
                  borderLeft: "1px solid #dfe3e6",
                }}
              >
                <DatePicker
                  disabled={is_locked}
                  onChange={(value) => {
                    handleCustomChange("second", "date", moment(value).format("MM/DD/YYYY"));
                  }}
                  style={{
                    width: "100%",
                    minWidth: "100%",
                    background: "transparent",
                    boxShadow: "none",
                    borderBottom: 0,
                  }}
                  format={"MM/DD/YYYY"}
                  placeholder="Date"
                  suffixIcon={<ExpandSVG />}
                />
              </div>

              <div
                className={`th sortable w-25 hide-icon`}
                style={{
                  paddingLeft: "2px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  alignSelf: "stretch",
                  borderLeft: "1px solid #dfe3e6",
                }}
              >
                <TimePicker
                  disabled={is_locked}
                  format={"h:mm A"}
                  use12Hours
                  placeholder="Time"
                  style={{
                    maxWidth: "100%",
                    width: "100%",
                    background: "transparent",
                    boxShadow: "none",
                    borderBottom: 0,
                  }}
                  disabledHours={() => [0, 1, 2, 3, 4, 5, 20, 21, 22, 23]}
                  minuteStep={15}
                  onChange={(value) => handleCustomChange("second", "time", moment(value).format("h:mm A"))}
                />
              </div>

              <div
                className={`th sortable w-25 hide-icon`}
                style={{
                  paddingLeft: "2px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  alignSelf: "stretch",
                  borderLeft: "1px solid #dfe3e6",
                }}
              >
                <Select
                  disabled={is_locked}
                  placeholder="Provider"
                  value={customAppointment["second"].provider || undefined}
                  suffixIcon={<span />}
                  allowClear={true}
                  style={{
                    maxWidth: "100%",
                    width: "100%",
                    background: "transparent",
                    borderBottom: 0,
                    boxShadow: "none",
                  }}
                  onChange={(value) => handleCustomChange("second", "provider", value)}
                >
                  {(followupProviders || []).map((provider, index) => (
                    <Option key={`provider-${provider?.id}-${index}`} value={provider?.id}>
                      {provider?.value}
                    </Option>
                  ))}
                </Select>
              </div>
            </div>
          )}
        </div>
      </div>
      {activeStatus || !lock || (firstClinic != -1 && secondClinic != -1) ? (
        <div className="actionContent" style={{ paddingRight: "10px", marginTop: 0, minHeight: "16px" }}>
          <button
            disabled={is_locked}
            className={`bottom-btn ${is_locked ? "disable-btn" : ""}`}
            onClick={() => {
              onHandleClick();
            }}
          >
            Continue
          </button>
        </div>
      ) : null}
    </>
  );
};

export default ClinicDiseaseComponent;
